/** Literal EN/HE titles — artwork names stay faithful to filename meaning; brands & proper nouns preserved. */
export type BilingualCopy = { en: string; he: string };

export const AI_ARTWORK_TITLES: Record<string, BilingualCopy> = {
  veshavu_action_figures1_realistic: {
    en: "Veshavu Action Figures — 1",
    he: "ושבו — דמויות אקשן — 1",
  },
  veshavu_action_figures2_realistic: {
    en: "Veshavu Action Figures — 2",
    he: "ושבו — דמויות אקשן — 2",
  },
  veshavu_action_figures3_realistic: {
    en: "Veshavu Action Figures — 3",
    he: "ושבו — דמויות אקשן — 3",
  },
  veshavu_action_figures4_realistic: {
    en: "Veshavu Action Figures — 4",
    he: "ושבו — דמויות אקשן — 4",
  },
  veshavu_action_figures5_realistic: {
    en: "Veshavu Action Figures — 5",
    he: "ושבו — דמויות אקשן — 5",
  },
  veshavu_action_figures6_realistic: {
    en: "Veshavu Action Figures — 6",
    he: "ושבו — דמויות אקשן — 6",
  },
  veshavu_action_figures7_realistic: {
    en: "Veshavu Action Figures — 7",
    he: "ושבו — דמויות אקשן — 7",
  },
  veshavu_action_figures8_realistic: {
    en: "Veshavu Action Figures — 8",
    he: "ושבו — דמויות אקשן — 8",
  },
  animals_as_couples_animals: {
    en: "Animals as Couples",
    he: "חיות כזוגות",
  },
  cat_animals: {
    en: "Cat",
    he: "חתול",
  },
  deer_animals: {
    en: "Deer",
    he: "אייל",
  },
  shellfish: {
    en: "Shellfish",
    he: "רכיכות",
  },
  sissi_with_a_pearl_earing_animals: {
    en: "Sissi with a Pearl Earring",
    he: "סיסי עם עגיל פנינה",
  },
  swans: {
    en: "Swans",
    he: "ברבורים",
  },
  whales_couple_animals: {
    en: "Whales Couple",
    he: "זוג לווייתנים",
  },
  bright_future_gate: {
    en: "Bright Future Gate",
    he: "שער לעתיד בהיר",
  },
  acts_vs_words_hands_go_higher_realistic: {
    en: "Acts vs Words — Hands Go Higher",
    he: "מעשים מעל מילים: ידיים עולות מעל הראש",
  },
  internal_sea_spirit: {
    en: "Internal Sea Spirit",
    he: "רוח ים פנימית",
  },
  mutant_baby_of_3: {
    en: "Mutant Baby of 3",
    he: "תינוק מוטאנט של שלושה",
  },
  pond_nice_quiet_place_to_meditate_to: {
    en: "Pond — Quiet Place to Meditate",
    he: "בריכה — מקום שקט למדיטציה",
  },
  rubber_atronout_realistic: {
    en: "Rubber Astronaut",
    he: "אסטרונאוט גומי",
  },
  children_book_cover: {
    en: "Children's Book Cover",
    he: "עטיפת ספר ילדים",
  },
  game3_board_havah: {
    en: "Game Board Havah — 3",
    he: "לוח משחק חווה — 3",
  },
  game_board10_havah: {
    en: "Game Board Havah — 10",
    he: "לוח משחק חווה — 10",
  },
  game_board2_havah: {
    en: "Game Board Havah — 2",
    he: "לוח משחק חווה — 2",
  },
  game_board4_havah: {
    en: "Game Board Havah — 4",
    he: "לוח משחק חווה — 4",
  },
  game_board5_havah: {
    en: "Game Board Havah — 5",
    he: "לוח משחק חווה — 5",
  },
  game_board7_havah: {
    en: "Game Board Havah — 7",
    he: "לוח משחק חווה — 7",
  },
  game_board8_havah: {
    en: "Game Board Havah — 8",
    he: "לוח משחק חווה — 8",
  },
  game_board9_havah: {
    en: "Game Board Havah — 9",
    he: "לוח משחק חווה — 9",
  },
  game_board_havah: {
    en: "Game Board Havah",
    he: "לוח משחק חווה",
  },
  havah_project_cover_the_women_health_app_havah: {
    en: "Havah — Women's Health App Cover",
    he: "חווה — עטיפת אפליקציית בריאות נשים",
  },
  heaven_goal_havah: {
    en: "Heaven Goal — Havah",
    he: "יעד גן עדן — חווה",
  },
  hormonic_periods_of_the_month_woman_health: {
    en: "Hormonal Periods of the Month — Women's Health",
    he: "מחזור הורמונלי — בריאות האישה",
  },
  "hungru_960's_call_for_food_critiques": {
    en: "Hungru — 60s Call for Food Critiques",
    he: "האנגרו — קריאה בסגנון שנות ה-60 לביקורות אוכל",
  },
  hungru_nuetral_call_for_food_critiques: {
    en: "Hungru — Neutral Call for Food Critiques",
    he: "האנגרו — קריאה ניטרלית לביקורות אוכל",
  },
  hungru_vibrant_call_for_food_critiques: {
    en: "Hungru — Vibrant Call for Food Critiques",
    he: "האנגרו — קריאה תוססת לביקורות אוכל",
  },
  hungru_vibrant_call_for_food_critiques2: {
    en: "Hungru — Vibrant Call for Food Critiques — 2",
    he: "האנגרו — קריאה תוססת לביקורות אוכל — 2",
  },
  butter_flavour_spirit_taste_identity_demo_hungru: {
    en: "Butter — Flavor Spirit — Taste Identity Demo — Hungru",
    he: "חמאה — רוח טעם — הדגמת זהות טעם — האנגרו",
  },
  citrus2_flavour_spirit_taste_identity_demo_hungru: {
    en: "Citrus 2 — Flavor Spirit — Taste Identity Demo — Hungru",
    he: "הדרים 2 — רוח טעם — הדגמת זהות טעם — האנגרו",
  },
  citrus_flavour_spirit_taste_identity_demo_hungru: {
    en: "Citrus — Flavor Spirit — Taste Identity Demo — Hungru",
    he: "הדרים — רוח טעם — הדגמת זהות טעם — האנגרו",
  },
  honey_flavour_spirit_taste_identity_demo: {
    en: "Honey — Flavor Spirit — Taste Identity Demo",
    he: "דבש — רוח טעם — הדגמת זהות טעם",
  },
  night_guy_flavour_spirit_taste_identity_demo: {
    en: "Night Guy — Flavor Spirit — Taste Identity Demo",
    he: "גיבור לילה — רוח טעם — הדגמת זהות טעם",
  },
  olive_flavour_spirit_taste_identity_demo: {
    en: "Olive — Flavor Spirit — Taste Identity Demo",
    he: "זית — רוח טעם — הדגמת זהות טעם",
  },
  pasta_flavour_spirit_taste_identity_demo: {
    en: "Pasta — Flavor Spirit — Taste Identity Demo",
    he: "פסטה — רוח טעם — הדגמת זהות טעם",
  },
  pickles_taste_identity_demo: {
    en: "Pickles — Taste Identity Demo",
    he: "חמוצים — הדגמת זהות טעם",
  },
  saint_flavour_spirit_taste_identity_demo: {
    en: "Saint — Flavor Spirit — Taste Identity Demo",
    he: "קדוש — רוח טעם — הדגמת זהות טעם",
  },
  seafood_flavour_spirit_taste_identity_demo_hungru: {
    en: "Seafood — Flavor Spirit — Taste Identity Demo — Hungru",
    he: "פירות ים — רוח טעם — הדגמת זהות טעם — האנגרו",
  },
  wine_flavour_spirit_taste_identity_demo: {
    en: "Wine — Flavor Spirit — Taste Identity Demo",
    he: "יין — רוח טעם — הדגמת זהות טעם",
  },
  the_near_future_of_hungru: {
    en: "The Near Future of Hungru",
    he: "העתיד הקרוב של האנגרו",
  },
  olive_human_taste_identity_demo: {
    en: "Olive — Human Taste Identity Demo",
    he: "זית — הדגמת זהות טעם אנושית",
  },
  stew_human_taste_identity_demo: {
    en: "Stew — Human Taste Identity Demo",
    he: "תבשיל — הדגמת זהות טעם אנושית",
  },
  wine_woman_human_taste_identity_demo: {
    en: "Wine Woman — Human Taste Identity Demo",
    he: "אישת יין — הדגמת זהות טעם אנושית",
  },
  inspiration_flows: {
    en: "Inspiration Flows",
    he: "השראה זורמת",
  },
  olymus_heaven: {
    en: "Olympus Heaven",
    he: "שמי האולימפוס",
  },
  superman_team2_realistic: {
    en: "Superman Team — 2",
    he: "צוות סופרמן — 2",
  },
  superman_team_action_figures1_realistic: {
    en: "Superman Team Action Figures — 1",
    he: "צוות סופרמן — דמויות אקשן — 1",
  },
  superman_team_realistic: {
    en: "Superman Team",
    he: "צוות סופרמן",
  },
  team_of_one_realistic: {
    en: "Team of One",
    he: "צוות של אחד",
  },
  the_alabanian_groom_realistic: {
    en: "The Albanian Groom",
    he: "החתן האלבני",
  },
};

export const AI_ARTWORK_DESCRIPTIONS: Record<string, BilingualCopy> = {
  sissi_with_a_pearl_earing_animals: {
    en: "After Vermeer's Girl with a Pearl Earring — Sissi, the studio dog, in turban and pearl.",
    he: "בהשראת «נערה עם עגיל פנינה» של ורמיר — סיסי, כלבת הסטודיו, בטורבן ועגיל פנינה.",
  },
};

function normalizeStem(imageFile: string): string {
  return imageFile.replace(/\.(png|webp|jpg)$/i, "");
}

export function aiTitleFromFile(imageFile: string, lang: "en" | "he"): string {
  const stem = normalizeStem(imageFile);
  const entry = AI_ARTWORK_TITLES[stem];
  if (entry) return entry[lang];
  return stem.replace(/_/g, " ");
}

export function aiDescriptionFromFile(imageFile: string, lang: "en" | "he"): string {
  const stem = normalizeStem(imageFile);
  return AI_ARTWORK_DESCRIPTIONS[stem]?.[lang] ?? "";
}
